"use strict";
const options_collection = {
  collectionsLoadMore: ".collections-load-more",
  rangeSlider: ".price-range .range-slider",
  rangeSliderMin: ".range-slider-min",
  rangeSliderMax: ".range-slider-max",
  minPriceRange: ".min-price-range",
  maxPriceRange: ".max-price-range",
  collectionSidebar: "#CollectionSidebar",
  collectionFilterBlocks: ".filter-blocks",
  productgridcontainer: "#productgridcontainer",
  collectionFiltersForm: "#CollectionFiltersForm",
  section: ".sec__collection-main",
};

class BtnFilter extends HTMLElement {
  constructor() {
    super();
    this.collectionSidebar = document.getElementById("CollectionSidebar");
    this.addEventListener("click", this.onOpen.bind(this), false);
  }
  onOpen() {
    if (!this.classList.contains("open")) {
      this.collectionSidebar.classList.add("open");
      document.documentElement.classList.add("open-drawer", "open-sidebar");
      root.style.setProperty("padding-right", getScrollBarWidth.init() + "px");
      this.classList.add("open");
    } else {
      this.collectionSidebar.classList.remove("open");
      document.documentElement.classList.remove("open-drawer", "open-sidebar");
      root.style.removeProperty("padding-right");
      this.classList.remove("open");
    }
  }
}
customElements.define("btn-filter", BtnFilter);

class CloseFilter extends HTMLElement {
  constructor() {
    super();
    this.collectionSidebar = document.getElementById("CollectionSidebar");
    this.addEventListener("click", this.onClose.bind(this), false);
  }
  onClose() {
    this.collectionSidebar.classList.remove("open");
    document.documentElement.classList.remove("open-drawer", "open-sidebar");
    document.querySelector(".btn-filter").classList.remove("open");
    root.style.removeProperty("padding-right");
  }
}
customElements.define("close-filter", CloseFilter);

class FacetApplyCanvas extends CloseFilter {
  constructor() {
    super();
    this.addEventListener("click", this.onClose.bind(this), false);
  }
}
customElements.define("facet-apply-canvas", FacetApplyCanvas);

class GridMode extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.gridMode.bind(this), false);
  }
  gridMode() {
    const view_mode = this.getAttribute("data-grid-mode");
    if (this.classList.contains("active")) return;
    if (view_mode == 1) return;
    for (var item of document.querySelectorAll("grid-mode")) {
      item.classList.remove("active");
    }
    const container_switch = document.querySelector(
      ".container-products-switch"
    );
    this.classList.add("active");
    const data_view_mode = container_switch.getAttribute("data-view-mode");
    container_switch.classList.remove("grid-columns-" + data_view_mode);
    container_switch.setAttribute("data-view-mode", view_mode);
    container_switch.classList.add("grid-columns-" + view_mode);
  }
}
customElements.define("grid-mode", GridMode);

class ViewMode extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.viewMode.bind(this), false);
  }
  viewMode() {
    const view_mode = this.getAttribute("data-view");
    if (this.classList.contains("actived")) return;
    var queryString = window.location.search;
    queryString = eventCollectionShopify.removeParam("view", queryString);
    if (view_mode == "list") {
      var searchParams = queryString.replace("?", "") + "&view=list";
    } else {
      var searchParams = queryString.replace("?", "") + "&view=grid";
    }
    const url = eventCollectionShopify.renderUrl(searchParams);
    eventCollectionShopify.renderSectionFilter(url, searchParams);
  }
}
customElements.define("view-mode", ViewMode);

class FilterItem extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.filterItem.bind(this), false);
  }
  filterItem() {
    if (this.querySelector(".tooltip")) {
      this.querySelector(".tooltip").classList.toggle("current-filter");
    } else {
      if (this.closest("li")) {
        this.closest("li").classList.toggle("current-filter");
      }
    }
    const url = this.getAttribute("data-href");
    eventCollectionShopify.renderSectionFilter(url);
  }
}
customElements.define("filter-item", FilterItem);

class FacetClearAll extends CloseFilter {
  constructor() {
    super();
    this.addEventListener("click", this.filterItem.bind(this), false);
  }
  filterItem() {
    const url = this.getAttribute("data-href");
    eventCollectionShopify.renderSectionFilter(url);
    this.onClose();
  }
}
customElements.define("facet-clear-all", FacetClearAll);

class FilterSort extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.filterSort.bind(this), false);
  }
  filterSort() {
    const value = this.getAttribute("value");
    let queryString = window.location.search;
    queryString = eventCollectionShopify.removeParam("sort_by", queryString);
    const searchParams = queryString.replace("?", "") + "&sort_by=" + value;
    const url = eventCollectionShopify.renderUrl(searchParams);
    eventCollectionShopify.renderSectionFilter(url, searchParams);
  }
}
customElements.define("filter-sort", FilterSort);

class SelectSorter extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.activeFilterSort.bind(this), false);
  }
  activeFilterSort() {
    if (this.closest(".select-custom").classList.contains("active")) {
      this.closest(".select-custom").classList.remove("active");
    } else {
      this.closest(".select-custom").classList.add("active");
    }
  }
}
customElements.define("select-sorter", SelectSorter);

var eventCollectionShopify = (function () {
  return {
    init: function () {
      this.ionRangeSlider();
      let windowWidth = window.innerWidth;
      if (windowWidth <= 1024) {
        const horizontal = document.querySelector(".horizontal-filter");
        if (horizontal) {
          const collapsible = document.querySelectorAll("collapsible-block");
          collapsible.forEach((e) => {
            e.classList.add("active");
          });
        }
      }
    },

    ionRangeSlider: function () {
      // IMPORTANT: there are TWO ".price-range" in your Liquid.
      // We must target the slider wrapper: ".drop-range" (this is where CSS vars live).
      const rangeWrap = document.querySelector(".drop-range.price-range");
      if (!rangeWrap) return;

      const minRange = rangeWrap.querySelector(options_collection.rangeSliderMin);
      const maxRange = rangeWrap.querySelector(options_collection.rangeSliderMax);

      const minPrice = document.querySelector(options_collection.minPriceRange);
      const maxPrice = document.querySelector(options_collection.maxPriceRange);

      if (!minRange || !maxRange || !minPrice || !maxPrice) return;

      // -----------------------------
      // ✅ FIX: LOCK BASE MIN ON FIRST PAGE LOAD
      // Liquid recalculates base_min_units after filtering (because collection.products becomes filtered set).
      // So we store the initial baseMin in sessionStorage and reuse it after any filter re-render.
      // -----------------------------
      const storageKeyMin = "collection_price_baseMin:" + window.location.pathname;
      const storageKeyMax = "collection_price_baseMax:" + window.location.pathname;

      const baseMinAttr = Number(minRange.getAttribute("min") || 0);
      const baseMaxAttr = Number(maxRange.getAttribute("max") || 0);

      if (!sessionStorage.getItem(storageKeyMin) && baseMinAttr > 0) {
        sessionStorage.setItem(storageKeyMin, String(baseMinAttr));
      }
      if (!sessionStorage.getItem(storageKeyMax) && baseMaxAttr > 0) {
        sessionStorage.setItem(storageKeyMax, String(baseMaxAttr));
      }

      const baseMin = Number(sessionStorage.getItem(storageKeyMin) || baseMinAttr || 0);
      const baseMax = Number(sessionStorage.getItem(storageKeyMax) || baseMaxAttr || 0);

      // Force DOM bounds to locked bounds so slider track math stays correct
      minRange.min = baseMin;
      maxRange.min = baseMin;
      minRange.max = baseMax;
      maxRange.max = baseMax;

      const RANGE = (baseMax - baseMin) || 1;
      const GAP = 100;

      // Do NOT rely on step="100" if baseMin isn't aligned.
      // Keep range input step as 1; we snap in JS.
      minRange.step = 1;
      maxRange.step = 1;

      const clamp = (n, min, max) => Math.max(min, Math.min(max, Number(n)));

      // Snap to 100 increments RELATIVE TO baseMin, while allowing exact baseMax.
      // Example baseMin=1299 => 1299, 1399, 1499...
      const snapRel100 = (val) => {
        let v = Number(val);

        if (v <= baseMin) return baseMin;
        if (v >= baseMax) return baseMax;

        const snapped = baseMin + Math.round((v - baseMin) / 100) * 100;
        return clamp(snapped, baseMin, baseMax);
      };

      // Correct percent math for non-zero min
      const pct = (val) => {
        const p = ((Number(val) - baseMin) / RANGE) * 100;
        return clamp(p, 0, 100);
      };

      const setFrom = (valUnits) => {
        rangeWrap.style.setProperty("--range-from", pct(valUnits) + "%");
      };

      const setTo = (valUnits) => {
        rangeWrap.style.setProperty("--range-to", pct(valUnits) + "%");
      };

      const setLabelMin = (valUnits) => {
        document.querySelector(".price-lable .min").innerHTML =
          Shopify.formatMoney(Number(valUnits) * 100, cartStrings.money_format);
      };

      const setLabelMax = (valUnits) => {
        document.querySelector(".price-lable .max").innerHTML =
          Shopify.formatMoney(Number(valUnits) * 100, cartStrings.money_format);
      };

      const parseInputNumber = (raw) => {
        if (raw === null || raw === undefined) return NaN;
        return Number(String(raw).replace(/,/g, "").trim());
      };

      const syncHidden = () => {
        // Make sure the Shopify facet inputs (these are your text inputs) get the slider values
        minPrice.value = Number(minRange.value);
        maxPrice.value = Number(maxRange.value);
      };

      const applyPriceFilter = () => {
        syncHidden();

        const form = document.querySelector(options_collection.collectionFiltersForm);
        if (!form) return;

        const formData = new FormData(form);
        const params = new URLSearchParams(formData).toString();

        const nameMin = minPrice.getAttribute("name");
        const nameMax = maxPrice.getAttribute("name");

        var queryString = window.location.search;
        queryString = this.removeParam(nameMin, queryString);
        queryString = this.removeParam(nameMax, queryString);

        var searchParams = queryString.replace("?", "") + "&" + params;
        const url = this.renderUrl(searchParams);
        this.renderSectionFilter(url, searchParams);
      };

      // --- INIT / REFRESH ---
      // Use Shopify's current facet values if present, else fall back to LOCKED bounds.
      let currentMin = parseInputNumber(minPrice.value);
      let currentMax = parseInputNumber(maxPrice.value);

      if (!Number.isFinite(currentMin) || currentMin <= 0) currentMin = baseMin;
      if (!Number.isFinite(currentMax) || currentMax <= 0) currentMax = baseMax;

      currentMin = clamp(snapRel100(currentMin), baseMin, baseMax);
      currentMax = clamp(snapRel100(currentMax), baseMin, baseMax);

      // Enforce gap
      if (currentMax - currentMin < GAP) {
        const candidateMax = clamp(currentMin + GAP, baseMin, baseMax);
        if (candidateMax - currentMin >= GAP) {
          currentMax = candidateMax;
        } else {
          currentMin = clamp(currentMax - GAP, baseMin, baseMax);
        }
      }

      minRange.value = currentMin;
      maxRange.value = currentMax;

      setLabelMin(currentMin);
      setLabelMax(currentMax);
      setFrom(currentMin);
      setTo(currentMax);

      // Prevent duplicate binding on same DOM instance
      if (rangeWrap.getAttribute("data-bound") === "1") return;
      rangeWrap.setAttribute("data-bound", "1");

      // TEXT INPUT: MIN
      document.querySelector(options_collection.minPriceRange).addEventListener(
        "change",
        (event) => {
          event.preventDefault();
          const target = event.currentTarget;

          let newMin = parseInputNumber(target.value);
          newMin = Number.isFinite(newMin) ? newMin : baseMin;

          newMin = clamp(snapRel100(newMin), baseMin, baseMax);
          const currMax = Number(maxRange.value);

          if (currMax - newMin < GAP) newMin = clamp(currMax - GAP, baseMin, baseMax);

          minRange.value = newMin;
          target.value = newMin; // keep input clean number
          setLabelMin(newMin);
          setFrom(newMin);

          applyPriceFilter();
        },
        false
      );

      // TEXT INPUT: MAX
      document.querySelector(options_collection.maxPriceRange).addEventListener(
        "change",
        (event) => {
          event.preventDefault();
          const target = event.currentTarget;

          let newMax = parseInputNumber(target.value);
          newMax = Number.isFinite(newMax) ? newMax : baseMax;

          newMax = clamp(snapRel100(newMax), baseMin, baseMax);
          const currMin = Number(minRange.value);

          if (newMax - currMin < GAP) newMax = clamp(currMin + GAP, baseMin, baseMax);

          maxRange.value = newMax;
          target.value = newMax;
          setLabelMax(newMax);
          setTo(newMax);

          applyPriceFilter();
        },
        false
      );

      // SLIDER MIN drag
      minRange.addEventListener(
        "input",
        (event) => {
          event.preventDefault();
          const target = event.currentTarget;

          // if (Number(maxRange.value) - Number(target.value) >= 1) {
          //   minPrice.value = Number(target.value);
          //   minPriceRange = Number(target.value) * 100;
          // } else {
          //   target.value = Number(maxRange.value) - 1;
          //   minPriceRange = (Number(maxRange.value) - 1) * 100;
          // }

          let newMin = clamp(snapRel100(target.value), baseMin, baseMax);
          const currMax = Number(maxRange.value);

          if (currMax - newMin < GAP) newMin = clamp(currMax - GAP, baseMin, baseMax);

          target.value = newMin;
          minPrice.value = newMin;

          setLabelMin(newMin);
          setFrom(newMin);
        },
        false
      );

      // SLIDER MAX drag
      maxRange.addEventListener(
        "input",
        (event) => {
          event.preventDefault();
          const target = event.currentTarget;

          // if (target.value - minRange.value >= 1) {
          //   maxPrice.value = target.value;
          //   maxPriceRange = Number(target.value) * 100;
          // } else {
          //   target.value = Number(minRange.value) + Number(1);
          //   maxPriceRange = (Number(minRange.value) + Number(1)) * 100;
          // }

          let newMax = clamp(snapRel100(target.value), baseMin, baseMax);
          const currMin = Number(minRange.value);

          if (newMax - currMin < GAP) newMax = clamp(currMin + GAP, baseMin, baseMax);

          target.value = newMax;
          maxPrice.value = newMax;

          setLabelMax(newMax);
          setTo(newMax);
        },
        false
      );

      // Apply filter on release (change)
      rangeWrap.querySelectorAll(".range-slider").forEach((sliderRange) => {
        sliderRange.addEventListener(
          "change",
          (event) => {
            event.preventDefault();

            let finalMin = clamp(snapRel100(minRange.value), baseMin, baseMax);
            let finalMax = clamp(snapRel100(maxRange.value), baseMin, baseMax);

            if (finalMax - finalMin < GAP) {
              const candidateMax = clamp(finalMin + GAP, baseMin, baseMax);
              if (candidateMax - finalMin >= GAP) finalMax = candidateMax;
              else finalMin = clamp(finalMax - GAP, baseMin, baseMax);
            }

            minRange.value = finalMin;
            maxRange.value = finalMax;

            minPrice.value = finalMin;
            maxPrice.value = finalMax;

            setLabelMin(finalMin);
            setLabelMax(finalMax);
            setFrom(finalMin);
            setTo(finalMax);

            applyPriceFilter();
          },
          false
        );
      });
    },

    removeParam: function (key, sourceURL) {
      var rtn = sourceURL.split("?")[0],
        param,
        params_arr = [],
        queryString =
          sourceURL.indexOf("?") !== -1 ? sourceURL.split("?")[1] : "";
      if (queryString !== "") {
        params_arr = queryString.split("&");
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
          param = params_arr[i].split("=")[0];
          if (param === key) {
            params_arr.splice(i, 1);
          }
        }
        if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
      }
      return rtn;
    },

    renderUrl: function (searchParams) {
      const sectionId = document.querySelector(options_collection.section)
        .dataset.sectionId;
      const url = `${window.location.pathname}?section_id=${sectionId}&${searchParams}`;
      return url;
    },

    renderSectionFilter: function (url, searchParams) {
      this.toggleLoading(document.body, true);
      fetch(`${url}`)
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            throw error;
          }
          return response.text();
        })
        .then((responseText) => {
          if (window.innerWidth <= 1024) {
            const collectionFilterBlocks = new DOMParser()
              .parseFromString(responseText, "text/html")
              .querySelector(options_collection.collectionFilterBlocks);
            document.querySelector(
              options_collection.collectionFilterBlocks
            ).innerHTML = collectionFilterBlocks.innerHTML;
            const productgridcontainer = new DOMParser()
              .parseFromString(responseText, "text/html")
              .querySelector(options_collection.productgridcontainer);
            document.querySelector(
              options_collection.productgridcontainer
            ).innerHTML = productgridcontainer.innerHTML;
            if (
              document
                .querySelector(options_collection.collectionSidebar)
                .classList.contains("open")
            ) {
              document.querySelector(".btn-filter").classList.add("open");
            }
          } else {
            const newSection = new DOMParser()
              .parseFromString(responseText, "text/html")
              .querySelector(options_collection.section);
            document
              .querySelector(options_collection.section)
              .replaceWith(newSection);
          }
          document.documentElement.classList.remove("hside_opened");
          this.toggleLoading(document.body, false);
        })
        .catch((error) => {
          throw error;
        })
        .finally(() => {
          initLazyloadItem();
          eventCollectionShopify.ionRangeSlider();
        });
      this.updateUrl(url, searchParams);
    },

    toggleLoading: function (event, loading) {
      if (event) {
        if (loading) {
          event.classList.add("start", "loading");
        } else {
          event.classList.add("finish");
          setTimeout(function () {
            event.classList.remove("start", "loading", "finish");
          }, 500);
        }
      }
    },

    updateUrl: function (url, searchParams = false) {
      if (searchParams) {
        const urlUpdate = `${window.location.pathname}?${searchParams}`;
        window.history.pushState({ url: urlUpdate }, "", urlUpdate);
      } else {
        window.history.pushState({ url: url }, "", url);
      }
    },
  };
})();

eventCollectionShopify.init();
